/*********************************************************************************************
 * Splide Tabs - Initialisation
 *
 */
function initializeSplideTabsHero(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : false,
        perPage     : 1,
        snap        : true,
        fixedWidth  : 'fit-content',
        gap         : '12px',
        focus       : 'center',
        breakpoints : {
            768: {
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
  initializeSectionsWithSplide('data-section-hero-id', '.mm-hero-collection-tabs-splide', initializeSplideTabsHero);
});